var _path, _path2, _g, _g2, _path3, _path4, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 57,
    viewBox: "0 0 71 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2920_5964)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9283 24.4861C60.2016 27.8429 59.3405 32.0094 56.0433 36.1897C49.4488 44.5503 35.607 49.8005 25.1267 47.9163C19.8866 46.9742 16.479 44.4269 15.2057 41.07L13.3815 36.2605C12.1082 32.9036 12.9693 28.7372 16.2665 24.5569C22.861 16.1963 36.7028 10.9461 47.1831 12.8303C52.4232 13.7724 55.8308 16.3197 57.1041 19.6766L58.9283 24.4861Z",
    fill: "url(#paint0_linear_2920_5964)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2920_5964",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 48,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9283 24.4863C60.2016 27.8432 59.3405 32.0096 56.0433 36.1899C49.4488 44.5506 35.607 49.8007 25.1267 47.9165C19.8866 46.9744 16.479 44.4271 15.2057 41.0702L13.3815 36.2608C12.1082 32.9039 12.9693 28.7375 16.2665 24.5571C22.861 16.1965 36.7028 10.9463 47.1831 12.8305C52.4232 13.7726 55.8308 16.32 57.1041 19.6768L58.9283 24.4863Z",
    fill: "url(#paint1_linear_2920_5964)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2920_5964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7555 28.2462L30.8248 32.3922L42.8032 37.6013L45.7883 45.4714L55.3923 37.8276L52.4072 29.9575L41.7555 28.2462Z",
    fill: "#ED9A15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6589 31.955L39.4034 28.6382L33.4555 40.6468L36.4406 48.5168L27.6584 49.0972L24.5075 40.7899L30.6589 31.955Z",
    fill: "#FFD454"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2920_5964)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.4375,
    cy: 12.4375,
    r: 12.4375,
    transform: "matrix(-0.987062 -0.160338 -0.632437 0.774612 55.3203 20.1501)",
    fill: "#FFA81E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 24.7525C11.9573 32.1537 14.7041 39.3954 24.1352 40.9274C33.5662 42.4594 46.1102 37.7015 52.1529 30.3003C58.1957 22.8991 55.4489 15.6574 46.0178 14.1254C36.5868 12.5935 24.0428 17.3514 18.0001 24.7525Z",
    stroke: "url(#paint2_linear_2920_5964)",
    strokeWidth: 0.935241
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8064 25.5332C18.4645 30.8511 20.4382 36.0545 27.2146 37.1552C33.991 38.256 43.0041 34.8373 47.346 29.5194C51.6878 24.2015 49.7142 18.9982 42.9377 17.8974C36.1613 16.7967 27.1482 20.2153 22.8064 25.5332Z",
    stroke: "url(#paint3_linear_2920_5964)",
    strokeWidth: 0.935241
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_2920_5964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3554 34.7582L33.3192 34.6536L36.4786 27.6328L40.2864 27.4984L41.3019 25.2418L30.7225 25.6152L29.707 27.8719L33.5148 27.7375L30.3554 34.7582ZM42.8816 21.7314L32.3022 22.1048L31.2867 24.3615L41.8661 23.988L42.8816 21.7314Z",
    fill: "#FFD454"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2920_5964",
    x: 11.8203,
    y: 11.4473,
    width: 48.668,
    height: 37.8523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_2920_5964"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2920_5964",
    x: 20.5938,
    y: 17.9497,
    width: 29.168,
    height: 19.6809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.40286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.573446 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2920_5964"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_2920_5964",
    x: 26.5469,
    y: 21.7314,
    width: 16.3359,
    height: 13.8626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.701431
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2920_5964"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2920_5964",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.467621
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2920_5964"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2920_5964",
    x1: 14.8367,
    y1: 15.9506,
    x2: 59.5389,
    y2: 41.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2920_5964",
    x1: 14.8367,
    y1: 15.9508,
    x2: 59.5389,
    y2: 41.5063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2920_5964",
    x1: 38.2079,
    y1: 8.27242,
    x2: 51.2271,
    y2: 38.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2920_5964",
    x1: 37.3493,
    y1: 13.5493,
    x2: 46.8003,
    y2: 35.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin2);
export default __webpack_public_path__ + "static/media/Coin2.145eac22454c8021e93c2ea2366f06f0.svg";
export { ForwardRef as ReactComponent };